import { render, staticRenderFns } from "./accountInfo.vue?vue&type=template&id=71f1d5aa&scoped=true"
import script from "./accountInfo.vue?vue&type=script&lang=js"
export * from "./accountInfo.vue?vue&type=script&lang=js"
import style0 from "./accountInfo.vue?vue&type=style&index=0&id=71f1d5aa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1d5aa",
  null
  
)

export default component.exports